module.exports = __webpack_public_path__ + "img/pricing-hero.c8cc974c.png";